"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const SlackGrayscale = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("g", { className: "slack__slack" }, /* @__PURE__ */ React.createElement("g", { className: "slack__Group slack__1" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#8790A6",
        d: "M6.216 14.641c0 1.162-.938 2.1-2.1 2.1-1.161 0-2.1-.938-2.1-2.1 0-1.161.939-2.1 2.1-2.1h2.1v2.1Zm1.05 0a2.1 2.1 0 0 1 2.1-2.1c1.162 0 2.101.939 2.101 2.1v5.25a2.099 2.099 0 0 1-2.1 2.101c-1.162 0-2.1-.939-2.1-2.1v-5.25Z",
        className: "slack__Vector"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#8790A6",
        d: "M9.367 6.208c-1.162 0-2.1-.938-2.1-2.1 0-1.161.938-2.1 2.1-2.1 1.161 0 2.1.939 2.1 2.1v2.1h-2.1Zm0 1.066a2.1 2.1 0 1 1 0 4.2H4.1a2.1 2.1 0 1 1 0-4.2h5.267Z",
        className: "slack__Vector",
        opacity: 0.4
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#8790A6",
        d: "M17.784 9.375c0-1.162.938-2.1 2.1-2.1 1.161 0 2.1.938 2.1 2.1 0 1.161-.939 2.1-2.1 2.1h-2.1v-2.1Zm-1.05 0a2.1 2.1 0 0 1-2.1 2.1 2.099 2.099 0 0 1-2.101-2.1V4.108c0-1.161.939-2.1 2.1-2.1 1.162 0 2.1.939 2.1 2.1v5.267Z",
        className: "slack__Vector",
        opacity: 0.8
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#8790A6",
        d: "M14.633 17.792c1.162 0 2.1.938 2.1 2.1 0 1.161-.938 2.1-2.1 2.1-1.161 0-2.1-.939-2.1-2.1v-2.1h2.1Zm0-1.05a2.1 2.1 0 0 1-2.1-2.1c0-1.162.939-2.101 2.1-2.101H19.9c1.161 0 2.1.939 2.1 2.1 0 1.162-.939 2.1-2.1 2.1h-5.267Z",
        className: "slack__Vector",
        opacity: 0.6
      }
    )))
  );
};
export default SlackGrayscale;
